
const m = window.require("@ember/-internals/views");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
